import api from '../services/api';

export interface PagedResult<T> {
    items: T[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
}

export interface CourierDetailsDTO {
    id: number;
    orderID: number;
    invoiceNo: string;
    invoiceDate: string;
    customerName: string;
    customerNumber: string;
    courierProviderID: number;
    courierProvider: string;
    trackingID: string | null;
    shipmentDate: string | null;
    noOfPackages: string | null;
    courieredByID: number | null;
    courierByName: string | null;
    courierProviderContactID: number | null;
    courierContactPerson: string | null;
    courierContactNumber: string | null;
}

export interface UpdateCourierDetailDTO {
    id: number;
    trackingID?: string | null;
    shipmentDate?: string | null;
    noOfPackages?: string | null;
    CourierByUserId?: number | null;
}

class CourierDetailsService {

    async getCourierTrackingDetails(
        startDate?: string,
        endDate?: string,
        keyword?: string,
        withCourierTrackingId: boolean = true,
        pageNumber: number = 1,
        pageSize: number = 10
    ): Promise<PagedResult<CourierDetailsDTO>> {

        const payload = {
            startDate: startDate ?? null,
            endDate: endDate ?? null,
            withCourierTrackingId,
            keyword: keyword ?? "",
            pageNumber,
            pageSize
        };

        const response = await api.post(
            '/api/CourierCharges/GetCourierTrackingDetails',
            payload
        );

        return {
            items: (response.data.courierTrackingDetails || []).map((x: any, index: number) => ({
                id: index + 1,           // Unique per row — orderId is NOT unique when 1 order has 2+ invoices
                orderID: x.orderId,
                invoiceNo: x.invoiceNo,
                invoiceDate: new Date(x.invoiceDate).toLocaleDateString('en-GB'),


                customerName: x.customerName,
                customerNumber: x.customerNumber,

                courierProviderID: x.courierProviderId,
                courierProvider: x.courierProviderName,

                trackingID: x.trackingId,
                shipmentDate: x.shipmentDate,
                noOfPackages: x.noofPackages,

                courieredByID: x.courieredById,
                courierByName: x.courierbyName || null,

                courierProviderContactID: null,
                courierContactPerson: x.courierContactName,
                courierContactNumber: x.courierContactPhone
            })),

            totalCount: response.data.totalRecords || 0,
            pageNumber,
            pageSize
        };

    }

    async saveOrderCourierDetail(updateDto: any): Promise<boolean> {
        try {
            const response = await api.post(
                '/api/CourierCharges/SaveCourierDetails',
                updateDto
            );

            return response.status === 200;

        } catch (error) {
            console.error('Save failed:', error);
            throw error;
        }
    }

}

export default new CourierDetailsService();